// Config for differentpages' versions based on geo location

export const GEO_LOCATION_CONFIG = {
	DEFAULT: {
		homepage: {
			// Template 1
			pagePath: '/',
			pageName: 'Homepage', // For mapping with SEO meta tags
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'The Leading AI-powered Cloud-Based Facilities Management Software',
			heroMessage:
				'Streamline operations, automate maintenance and improve efficiency with our powerful, easy-to-use facilities management software',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	IN: {
		homepage: {
			// Template 1
			pagePath: '/in',
			pageName: 'Homepage India',
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in India',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in India.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	MY: {
		homepage: {
			// Template 1
			pagePath: '/my',
			pageName: 'Homepage Malaysia',
			headingList: [
				'Revolutionize Facilities Management in Malaysia with FacilityBot CMMS',
				'Use a single, powerful platform for all your facilities management needs in Malaysia.',
				'Award-Winning Facilities Management Software / CMMS in Malaysia',
			],
			heroTagline: 'The Leading AI-powered Cloud-Based Facilities Management Software in Malaysia',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our award-winning Facilities Management Software (CMMS) for Malaysia.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	PH: {
		homepage: {
			// Template 1
			pagePath: '/ph',
			pageName: 'Homepage Philippines',
			headingList: [
				'Revolutionize Facilities Management in the Philippines with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in the Philippines',
				'Award-Winning Facilities Management Software / CMMS in the Philippines',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in the Philippines',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in the Philippines.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	AE: {
		homepage: {
			// Template 1
			pagePath: '/ae',
			pageName: 'Homepage UAE',
			headingList: [
				'Revolutionize Facilities Management in Dubai with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Dubai',
				'Award-Winning Facilities Management Software / CMMS in Dubai',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Dubai',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Dubai.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	US: {
		homepage: {
			// Template 1
			pagePath: '/us/',
			pageName: 'Homepage United States',
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in the United States',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in the United States.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	SA: {
		homepage: {
			// Template 1
			pagePath: '/sa',
			pageName: 'Homepage Saudi Arabia',
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Saudi Arabia',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Saudi Arabia.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	HK: {
		homepage: {
			// Template 1
			pagePath: '/hk',
			pageName: 'Homepage Hong Kong',
			headingList: [
				'Revolutionize your Facilities Management with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs',
				'Award-Winning Facilities Management Software / CMMS',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Hong Kong',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Hong Kong.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			areaServed: 'Hong Kong',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	VN: {
		homepage: {
			// Template 1
			pagePath: '/vn',
			pageName: 'Homepage Vietnam',
			headingList: [
				'Revolutionize Facilities Management in Vietnam with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Vietnam',
				'Award-Winning Facilities Management Software / CMMS in Vietnam',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Vietnam',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Vietnam.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
			areaServed: 'Vietnam',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	TH: {
		homepage: {
			// Template 1
			pagePath: '/th',
			pageName: 'Homepage Thailand',
			headingList: [
				'Revolutionize Facilities Management in Thailand with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Thailand',
				'Award-Winning Facilities Management Software / CMMS in Thailand',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Thailand',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Thailand.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
			areaServed: 'Thailand',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	AU: {
		homepage: {
			// Template 1
			pagePath: '/au',
			pageName: 'Homepage Australia',
			headingList: [
				'Revolutionize Facilities Management in Australia with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Australia',
				'Award-Winning Facilities Management Software / CMMS in Australia',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Australia',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Australia.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
			areaServed: 'Australia',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
	ID: {
		homepage: {
			// Template 1
			pagePath: '/id',
			pageName: 'Homepage Indonesia',
			headingList: [
				'Revolutionize Facilities Management in Indonesia with FacilityBot CMMS',
				'Use a single platform for all your Facilities Management needs in Indonesia',
				'Award-Winning Facilities Management Software / CMMS in Indonesia',
			],
			heroTagline: 'Leading AI-powered Cloud-Based Facilities Management Software in Indonesia',
			heroMessage:
				'Streamline operations, automate maintenance, and improve efficiency with our powerful and user-friendly facilities management software in Indonesia.',
			heroCtaText: 'sign up for a 14-day free trial',
			heroMailHeader: 'Or Schedule Demo',
			heroWatchVideoDemoHeader: 'Or Watch Virtual Demo',
			heroClientFeedbacksHeader: 'See what our clients are saying',
			heroEmailText: 'sales@facilitybot.co',
			faultNumberMessage: 'Trusted by Industry Leaders Worldwide',
			areaServed: 'Indonesia',
		},
		pricing: {
			pagePath: '/pricing-plans',
		},
		clientFeedbacks: {
			pagePath: '/client-feedbacks',
		},
	},
};
